import useStoreSelector from './useStoreSelector';

export default useStoreSelector;
